import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

const useCarriers = ({ storeId, doInitialRequest } = {}) => {
  const {
    data: carriers,
    loading: fetchingCarriers,
    fetchData: fetchCarriers,
  } = useFetch(commonServices.getCarriers, {
    doInitialRequest,
    params: { storeId },
  })

  return {
    carriers: carriers || [],
    fetchingCarriers,
    fetchCarriers,
  }
}

export default useCarriers
